module.exports = __webpack_public_path__ + "img/link_beampower.1bfec4ac.png";